var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useState, useRef } from 'react';
import { Form } from './Form/Form';
import Button from './base/Button/Button';
import { generateId } from '../utils';
import { EventIcon } from './base/Icons/EventIcon';
function ModalComponent(_a) {
    var id = _a.id, dayIndex = _a.dayIndex, isFutureWeek = _a.isFutureWeek, open = _a.open, fromApp = _a.fromApp, rotations = _a.rotations, contacts = _a.contacts, onClose = _a.onClose, onChange = _a.onChange, viewMode = _a.viewMode, isOverrideMode = _a.isOverrideMode, slotDate = _a.slotDate, timezone = _a.timezone;
    var _b = useState(null), rotation = _b[0], setRotation = _b[1];
    var dialogRef = useRef(null);
    var dateStr = slotDate || new Date().toISOString().split('T')[0];
    useEffect(function () {
        if (id) {
            var updateRotation = rotations.find(function (r) { return r.id === id; });
            if (!updateRotation)
                return;
            var newRotation = __assign({}, updateRotation);
            if (isFutureWeek && (updateRotation === null || updateRotation === void 0 ? void 0 : updateRotation.serviceStatus) === 'available') {
                newRotation.id = generateId();
                newRotation.serviceStatus = 'override_future';
                newRotation.date = dateStr;
            }
            if (isFutureWeek && (updateRotation === null || updateRotation === void 0 ? void 0 : updateRotation.serviceStatus) === 'no_service') {
                newRotation.id = generateId();
                newRotation.serviceStatus = 'override_no_service';
                newRotation.date = dateStr;
            }
            if (isFutureWeek && (updateRotation === null || updateRotation === void 0 ? void 0 : updateRotation.serviceStatus) === 'override') {
                newRotation.serviceStatus = 'override_future';
            }
            setRotation(newRotation);
        }
        else if (isOverrideMode) {
            // Initialize as override with slotDate or today's date
            setRotation({
                id: generateId(),
                from: dayIndex,
                to: dayIndex < 0 ? -1 : dayIndex + 1,
                serviceStatus: 'override',
                date: dateStr,
            });
        }
        else {
            setRotation({
                id: generateId(),
                from: dayIndex,
                to: dayIndex + 1,
                serviceStatus: 'available_new',
            });
        }
    }, [id, dayIndex, rotations, isOverrideMode, slotDate]);
    useEffect(function () {
        if (open && dialogRef.current) {
            dialogRef.current.showModal();
        }
        else if (dialogRef.current) {
            dialogRef.current.close();
        }
    }, [open]);
    // Handle backdrop click to close modal
    var handleDialogClick = function (e) {
        if (e.target === dialogRef.current) {
            onClose();
        }
    };
    // Handle Escape key
    useEffect(function () {
        var handleEscape = function (e) {
            if (e.key === 'Escape' && open)
                onClose();
        };
        document.addEventListener('keydown', handleEscape);
        return function () { return document.removeEventListener('keydown', handleEscape); };
    }, [open, onClose]);
    return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    React.createElement("dialog", { ref: dialogRef, onClick: handleDialogClick, className: fromApp === 'spp' ? 'spp' : undefined, "data-testid": "tech-rotation-modal" },
        React.createElement("div", { style: {
                display: 'flex',
                flexDirection: 'column',
                minHeight: '300px',
                maxHeight: '95vh',
            }, "data-testid": "tech-rotation-modal-content" },
            React.createElement("div", { style: {
                    backgroundColor: fromApp === 'oncall' ? 'var(--oncall-color-primary)' : '#f5f5f5',
                    color: fromApp === 'oncall' ? 'white' : 'black',
                    padding: '12px 16px 12px 0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: fromApp === 'oncall' ? 'center' : 'space-between',
                    borderBottom: '1px solid #e0e0e0',
                }, "data-testid": "tech-rotation-modal-header" }, fromApp === 'oncall' ? (React.createElement("div", { style: { margin: '25px' } },
                React.createElement(EventIcon, { size: "xlarge", color: "#FFFFFF" }))) : (React.createElement("h3", { style: { margin: 0, fontWeight: 500 } }, "Contacts to Authorize Service"))),
            React.createElement("div", { style: {
                    padding: '20px',
                    overflowY: 'auto',
                    flex: 1,
                }, "data-testid": "tech-rotation-modal-body" },
                fromApp === 'oncall' && (React.createElement("div", { style: { textAlign: 'center', marginBottom: '20px' } },
                    React.createElement("h2", { style: { fontWeight: 500 }, "data-testid": "tech-rotation-modal-title" }, "Create After-Hours Rotation"))),
                rotation
                    && (React.createElement(Form, { fromApp: fromApp, rotation: rotation, rotations: rotations, contacts: contacts, onClose: onClose, onChange: onChange, viewMode: viewMode, isOverrideMode: isOverrideMode, slotDate: slotDate, timezone: timezone }))))));
}
export function Modal(_a) {
    var id = _a.id, fromApp = _a.fromApp, dayIndex = _a.dayIndex, isFutureWeek = _a.isFutureWeek, open = _a.open, rotations = _a.rotations, contacts = _a.contacts, onClose = _a.onClose, onChange = _a.onChange, viewMode = _a.viewMode, isOverrideMode = _a.isOverrideMode, slotDate = _a.slotDate, timezone = _a.timezone;
    if (!open)
        return null;
    return (React.createElement(ModalComponent, { id: id, dayIndex: dayIndex, isFutureWeek: isFutureWeek, open: open, fromApp: fromApp, rotations: rotations, contacts: contacts, onClose: onClose, onChange: onChange, viewMode: viewMode, isOverrideMode: isOverrideMode, slotDate: slotDate, timezone: timezone }));
}
export function ConfirmModal(_a) {
    var open = _a.open, title = _a.title, message = _a.message, _b = _a.confirmText, confirmText = _b === void 0 ? 'Confirm' : _b, _c = _a.cancelText, cancelText = _c === void 0 ? 'Cancel' : _c, onConfirm = _a.onConfirm, onCancel = _a.onCancel, _d = _a.fromApp, fromApp = _d === void 0 ? 'spp' : _d;
    var dialogRef = useRef(null);
    useEffect(function () {
        if (open && dialogRef.current) {
            dialogRef.current.showModal();
        }
        else if (dialogRef.current) {
            dialogRef.current.close();
        }
    }, [open]);
    var handleDialogClick = function (e) {
        if (e.target === dialogRef.current) {
            onCancel();
        }
    };
    useEffect(function () {
        var handleEscape = function (e) {
            if (e.key === 'Escape' && open)
                onCancel();
        };
        document.addEventListener('keydown', handleEscape);
        return function () { return document.removeEventListener('keydown', handleEscape); };
    }, [open, onCancel]);
    if (!open)
        return null;
    return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    React.createElement("dialog", { ref: dialogRef, onClick: handleDialogClick, className: fromApp === 'spp' ? 'spp' : undefined, "data-testid": "tech-rotation-confirm-modal" },
        React.createElement("div", { style: {
                display: 'flex',
                flexDirection: 'column',
                minWidth: '350px',
                maxWidth: '450px',
            }, "data-testid": "tech-rotation-confirm-modal-content" },
            React.createElement("div", { style: {
                    backgroundColor: fromApp === 'oncall' ? 'var(--oncall-color-primary)' : '#f5f5f5',
                    color: fromApp === 'oncall' ? 'white' : 'black',
                    padding: '12px 16px 12px 0',
                    borderBottom: '1px solid #e0e0e0',
                }, "data-testid": "tech-rotation-confirm-modal-header" },
                React.createElement("h3", { style: { margin: 0, fontWeight: fromApp === 'oncall' ? 'bold' : 500 }, "data-testid": "tech-rotation-confirm-modal-title" }, title)),
            React.createElement("div", { style: {
                    padding: '20px',
                }, "data-testid": "tech-rotation-confirm-modal-body" },
                React.createElement("p", { style: { margin: 0, fontSize: '14px', lineHeight: 1.5 }, "data-testid": "tech-rotation-confirm-modal-message" }, message)),
            React.createElement("div", { style: {
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: '12px',
                    padding: '16px 20px',
                    borderTop: '1px solid #e0e0e0',
                    backgroundColor: '#fafafa',
                }, "data-testid": "tech-rotation-confirm-modal-actions" },
                React.createElement(Button, { type: "button", variant: "outlined", size: "small", onClick: onCancel, "data-testid": "tech-rotation-confirm-cancel-btn" }, cancelText),
                React.createElement(Button, { type: "button", variant: "contained", size: "small", onClick: onConfirm, "data-testid": "tech-rotation-confirm-btn" }, confirmText)))));
}
//# sourceMappingURL=Modal.js.map